module.exports = {"dropDownPlaceholder":"Adobe ID を使用せずにサインイン"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/ja_jp.json
// module id = 931
// module chunks = 0